import React, { useState, useEffect, useLayoutEffect } from "react";
import { Redirect } from "react-router-dom";
import Loading from "../ui/Loading.js";
import $ from "jquery";
import "xlsx/dist/xlsx.full.min.js";
import {Grid} from '@material-ui/core';
import { FormattedMessage, injectIntl } from "react-intl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as Utils from '../../commons/utils/Utils';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import PresupuestoDetalladoTareaGrid from "./PresupuestoDetalladoTareaGrid.js";
import MenuItem from '@material-ui/core/MenuItem';
import Box from "@material-ui/core/Box";
import { limitMontoDigits } from '../ui/commons/inputs';
import { formatCost } from '../../commons/utils/Helpers';
import { faltaCampoObligatorio } from './obligatoriosPresupuesto';
import { CANTIDAD_STEP, recortarCantidad, bloquearTeclaCantidad } from './cantidadDecimal';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
};

const requiredSymbol = ' *';

const NEW_TAREA_INIT = {
	id: null,
	external_code: '',
	nombre: '',
	detalle: '',
	cuenta_mayor: '',
	cuenta_mayor_descripcion: '',
	precio: '',
	cantidad: '',
	servicio_id: null,
	servicio: '',
};

const PresupuestoDetalladoTarea = (props) => {
	const intl = props.intl;
	const [loading, setLoading] = useState(false);
	const [redirectTo, setRedirectTo] = useState(null);
	const [newPresupuestoTarea, setNewPresupuestoTarea] = useState({ ...NEW_TAREA_INIT })
	const [tareas, setTareas] = useState([]);
	const [servicios, setServicios] = useState([]);
	const [servicio, setServicio] = useState('');
	const [mecanicos, setMecanicos] = useState([]);
	const [busquedaPor, setBusquedaPor] = useState(() => {
		const nombreIndex = props.showTareas.indexOf('nombre');
		const servicioIndex = props.showTareas.indexOf('servicio');
		if (servicioIndex !== -1 && nombreIndex !== -1 && servicioIndex < nombreIndex) {
			return 'servicio';
		}
		return 'nombre';
	});

	// VEC-2591: restringe servicios/tareas a los del proveedor asignado del ticket.
	const serviciosProveedoresHabilitado = ConfigBusiness.get('servicios.proveedores.habilitado') === 'true';
	const gerenciadorId = props.ticket && props.ticket.gerenciador && props.ticket.gerenciador.id ? props.ticket.gerenciador.id : null;
	const proveedorServicioQS = (serviciosProveedoresHabilitado && gerenciadorId) ? ('&gerenciadorId=' + gerenciadorId) : '';
	const proveedorTareaQS = (serviciosProveedoresHabilitado && gerenciadorId) ? ('&gerenciadorId=' + gerenciadorId + '&ticketTipo=' + props.ticket.ticketTipo) : '';

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
		if(props.showTareas && props.showTareas.includes('mecanico')){
			loadMecanicos();
		}
	}, [props.ticket && props.ticket.taller ? props.ticket.taller.id : null]);

	const init = () => {
		loadInit(null)
		if(busquedaPor === 'servicio'){
			loadServices(null);
		}
		if(props.showTareas && props.showTareas.includes('mecanico')){
			loadMecanicos();
		}
	}

	const loadMecanicos = () => {
		var tallerId = props.ticket && props.ticket.taller ? props.ticket.taller.id : null;
		if(!tallerId){ return; }
		Utils.getData('/usuarios/mecanicos-por-taller/' + tallerId)
		.then(function(data) {
			setMecanicos(data.map(function(m) {
				return Object.assign({}, m, { nombreCompleto: m.nombre + ' ' + m.apellido });
			}));
		});
	}

	const renderField = (field) => {
		switch (field) {
			case 'id':
				return (
					<Grid component={Box} item xs={2} key="id">
						<form noValidate autoComplete="off">
							<Autocomplete
								clearText="Clear"
								type="number"
								id="id"
								name="id"
								options={tareas}
								value={newPresupuestoTarea}
								getOptionLabel={(option) => option.id ? option.id.toString() : ''}
								onChange={(event, value) => handleFormChangeSelectObject(value)}
								renderInput={(params) => (
									<TextField {...params}
										type="number"
										label={intl.formatMessage({ id: "Presupuesto.Id", defaultMessage: "Id" })}
										placeholder={intl.formatMessage({id: 'Presupuesto.Id', defaultMessage: 'Id'})}
										onChange={handleInputChange}
										
									/>
								)}
							/>
						</form>
					</Grid>
				);
			case 'external_code':
				return (
					<Grid component={Box} item xs={2} key="external_code">
						<form noValidate autoComplete="off">
							<TextField
								id="external_code"
								InputLabelProps={newPresupuestoTarea.external_code ? { shrink: true} : {}}
								label={intl.formatMessage({ id: 'Presupuesto.Tarea', defaultMessage: 'Tarea' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Tarea', defaultMessage: 'Tarea' })}
								value={newPresupuestoTarea.external_code}
								onChange={e => handleMaterialChange('external_code', e.target.value)}
								className="col-12"
							/>
						</form>
					</Grid>
				);
			case 'nombre':
				return (
					<Grid component={Box} item xs={2} key="nombre">
						<form noValidate autoComplete="off">
							<Autocomplete
								disabled={busquedaPor === 'nombre' ? false : (newPresupuestoTarea.servicio ? false : true)}
								id="nombre"
								name="nombre"
								options={tareas}
								value={newPresupuestoTarea}
								getOptionLabel={(option) => option.nombre ? option.nombre : ''}
								onChange={(event, value) => handleFormChangeSelectObject(value)}
								onBlur={(e) => busquedaPor === 'nombre' ? resetSelect(newPresupuestoTarea, 'nombre') : null}
								renderInput={(params) => (
									<TextField {...params}
										label={intl.formatMessage({ id: "Presupuesto.Descripción", defaultMessage: "Descripción" })}
										placeholder={intl.formatMessage({id: 'Presupuesto.Descripción', defaultMessage: 'Descripción'})}
										onChange={handleInputChange}
									/>
								)}
							/>
						</form>
          			</Grid>
				);
			case 'cuenta_mayor':
				return (
					<Grid component={Box} item xs={2} key="cuenta_mayor">
						<form noValidate autoComplete="off">
							<TextField
								disabled={newPresupuestoTarea.external_code || newPresupuestoTarea.descripcion ? false : true}
								id="cuenta_mayor"
								type="text"
								select
								label={intl.formatMessage({ id: 'Presupuesto.Cuenta_Mayor', defaultMessage: 'Cuenta Mayor' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Cuenta_Mayor', defaultMessage: 'Cuenta Mayor' })}
								onChange={(e) => handleChangeSelectServicio(e.target.value)}
								value={newPresupuestoTarea.cuenta_mayor}
								className="col-12"
								InputLabelProps={newPresupuestoTarea.cuenta_mayor ? { shrink: true} : {}}
							>
								{servicios.map(option => (
									<MenuItem key={option.id} value={option}>
										{option.external_code}
									</MenuItem>
								))}
							</TextField>
						</form>
					</Grid>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<Grid component={Box} item xs={2} key="cuenta_mayor_descripcion">
						<form noValidate autoComplete="off">
							<TextField
								disabled={true}
								id="cuenta_mayor_descripcion"
								type="text"
								InputLabelProps={newPresupuestoTarea.cuenta_mayor_descripcion ? { shrink: true} : {}}
								label={intl.formatMessage({ id: 'Presupuesto.descrip._Cuenta_Mayor', defaultMessage: 'Descrip. Cuenta Mayor' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.descrip._Cuenta_Mayor', defaultMessage: 'Descrip. Cuenta Mayor' })}
								value={newPresupuestoTarea.cuenta_mayor_descripcion}
								onChange={e => handleMaterialChange('cuenta_mayor_descripcion', e.target.value)}
								className="col-12"
							/>
						</form>
					</Grid>
				);
			case 'cantidad':
				return (
					<Grid component={Box} item xs={1} key="cantidad">
						<form noValidate autoComplete="off">
							<TextField
								id="cantidad"
								type="text"
								InputLabelProps={newPresupuestoTarea.cantidad ? { shrink: true} : {}}
								InputProps={{
									inputProps: { min: 0, inputMode: 'decimal', step: CANTIDAD_STEP }
								}}
								label={intl.formatMessage({ id: 'Presupuesto.Cantidad', defaultMessage: 'Cantidad' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Cantidad', defaultMessage: 'Cantidad' })}
								value={newPresupuestoTarea.cantidad}
								// VEC-3556: la MO cargada como tarea admite decimales → horas fraccionadas.
								// VEC-3570: tope de 2 decimales, misma regla que los ítems (cantidadDecimal.js).
								onChange={e => handleMaterialChange('cantidad', recortarCantidad(e.target.value))}
								onKeyDown={bloquearTeclaCantidad}
								className="col-12"
							/>
						</form>
					</Grid>
				);
			case 'precio':
				return (
					<Grid component={Box} item xs={2} key="precio">
						<form noValidate autoComplete="off">
							<TextField
								id="precio"
								type="number"
								InputLabelProps={newPresupuestoTarea.precio ? { shrink: true} : {}}
								InputProps={{
									inputProps: { min: 0 }
								}}
								label={intl.formatMessage({ id: 'Presupuesto.Precio', defaultMessage: 'Precio' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Precio', defaultMessage: 'Precio' })}
								value={newPresupuestoTarea.precio}
								onChange={e => handleMaterialChange('precio', e.target.value)}
								className="col-12"
							/>
						</form>
					</Grid>
				);
			case 'detalle':
				return (
					<Grid component={Box} item xs={2} key="detalle">
						<form noValidate autoComplete="off">
							<TextField
								id="detalle"
								type="text"
								InputLabelProps={newPresupuestoTarea.detalle ? { shrink: true} : {}}
								label={intl.formatMessage({ id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' })}
								value={newPresupuestoTarea.detalle}
								onChange={e => {
									const value = e.target.value;
									if (value.length <= 60) {
										handleMaterialChange('detalle', value);
									}
								}}
								className="col-12"
								InputProps={{
									endAdornment: (
										<InputAdornment position="end" style={{ marginLeft: 'auto' }}>
											<span style={{ fontSize: '0.75rem', color: '#666' }}>
												{newPresupuestoTarea.detalle ? newPresupuestoTarea.detalle.length : 0}/60
											</span>
										</InputAdornment>
									)
								}}
								inputProps={{ 
									maxLength: 60,
									style: { 
										overflow: 'auto',
										whiteSpace: 'nowrap'
									}
								}}
							/>
						</form>
					</Grid>
				);
			case 'servicio':
				return (
					<Grid component={Box} item xs={2} key="servicio">
						<form noValidate autoComplete="off">
							<Autocomplete
								disabled={busquedaPor === 'nombre' ? (newPresupuestoTarea.nombre ? false : true) : false}
								id="servicio"
								name="servicio"
								options={servicios}
								value={newPresupuestoTarea.servicio}
								getOptionLabel={(option) => option.nombre ? option.nombre : ''}
								onChange={(event, value) => busquedaPor === 'servicio' ? handleFormChangeSelectServicio(value) : handleChangeSelectServicio(value)}
								renderInput={(params) => (
									<TextField {...params}
										label={intl.formatMessage({ id: 'Presupuesto.Servicio', defaultMessage: 'Servicio' })}
										placeholder={intl.formatMessage({ id: 'Presupuesto.Servicio', defaultMessage: 'Servicio' })}
									/>
								)}
							/>
						</form>
          			</Grid>
				);
			default:
				return null;
		}
	}

	const resetSelect = (item, column) => {
		if(!item.nombre){
			loadInit(column);
		}
	};

	const setLoadingAndUpdate = (state) => {
		setLoading(state);
	};

	const handleMaterialChange = (name, value) => {
		let copy = JSON.parse(JSON.stringify(newPresupuestoTarea));
		if (name === "precio") {
			const limited = limitMontoDigits(value);
			if ((limited && limited >= 0) || !limited) {
				copy[name] = limited;
			}
		} else {
			copy[name] = value;
		}
		copy.servicio = newPresupuestoTarea.servicio
		setNewPresupuestoTarea(copy)
	};

	const handleFormChangeSelectObject = (value) => {
		let copy = JSON.parse(JSON.stringify(newPresupuestoTarea));
		if(value){
			copy.external_code = value.external_code ? value.external_code : ''
			copy.nombre = value.nombre ? value.nombre : ''
			copy.cuenta_mayor = value.cuenta_mayor ? value.cuenta_mayor : ''
			copy.cuenta_mayor_descripcion = value.cuenta_mayor_descripcion ? value.cuenta_mayor_descripcion : ''
			copy.precio = value.precio ? value.precio : "0"
			copy.id_tarea = value.id
			copy.id = value.id
			// Al cambiar la tarea en modo nombre-first, resetear el servicio previo
			// para no quedar con un par tarea↔servicio incoherente (input "sucio").
			if(busquedaPor === 'nombre'){
				copy.servicio = null;
				copy.servicio_id = null;
				copy.cantidad = '';
				loadServices(value.id);
			}
		}else{
			copy.id = '';
			copy.nombre = ''
			copy.id_tarea = null
			if(busquedaPor === 'nombre'){
				copy.servicio = null;
				copy.servicio_id = null;
			}
			copy.cantidad = '';
			copy.precio = '';
			loadInit(null);
		}
		setNewPresupuestoTarea(copy)
	};

	const handleFormChangeSelectServicio = (value) => {
		let copy = JSON.parse(JSON.stringify(newPresupuestoTarea));
		if(value){
			copy.external_code = value.external_code ? value.external_code : ''
			copy.servicio = value
			copy.servicio_id = value.id ? value.id : ''
			copy.precio = value.precio ? value.precio : "0"
			copy.nombre = '';
			copy.id_tarea = '';
			copy.precio = '';
			copy.cantidad = '';
			loadTareas(value.id)
		}else{
			copy.id = '';
			copy.nombre = '';
			copy.servicio = null;
			copy.servicio_id = null;
			copy.id_tarea = '';
			copy.precio = '';
			copy.cantidad = '';
			loadInit(null);
		}
		setNewPresupuestoTarea(copy)
	};

	const addTarea = () => {
		newPresupuestoTarea.cantidad = newPresupuestoTarea.cantidad ? newPresupuestoTarea.cantidad : 1;
		props.addTarea(newPresupuestoTarea)
		setNewPresupuestoTarea({ ...NEW_TAREA_INIT })
	};

	const handleInputChange = (e) => {
		let value = e.target.value;
		let column = e.target.id;
		console.log('handleInputChange', column, value);
		console.log(busquedaPor);
		if(busquedaPor === 'nombre'){
			Utils.getData('/tareas/simple-search-presupuesto?column=' + column + '&value=' + value + proveedorTareaQS)
			.then((data) => {
				setTareas(data)
			});
		}
	};
	
	// VEC-3436: ver obligatoriosPresupuesto.js (0 es válido para costo/precio; resuelve el alias costo↔precio).
	const validate = () => faltaCampoObligatorio(newPresupuestoTarea, props.obligatorios);

	const handleChangeSelectServicio = (value) => {
		setServicio(value);
		let copy = JSON.parse(JSON.stringify(newPresupuestoTarea));
		if(value){
			copy['cuenta_mayor'] = value.external_code
			copy['cuenta_mayor_descripcion'] = value.nombre
			copy['servicio_id'] = value.id;
			copy['servicio'] = value;
		}else{
			copy['cuenta_mayor'] = ''
			copy['cuenta_mayor_descripcion'] = ''
			copy['servicio_id'] = null;
			copy['servicio'] = '';
		}
		setNewPresupuestoTarea(copy)
	};

	const loadServices = (tareaId) => {
		if(tareaId){
			Utils.getData('/servicios/simple-search-presupuesto?tipo=tarea&ticketTipo=' + props.ticket.ticketTipo + '&tareaId=' + tareaId + proveedorServicioQS)
			.then((data) => {
				setServicios(data)
			});
		}else{
			Utils.getData('/servicios/simple-search-presupuesto?tipo=tarea&ticketTipo=' + props.ticket.ticketTipo + proveedorServicioQS)
			.then((data) => {
				setServicios(data)
			});
		}
	}

	const loadTareas = (servicioId) => {
		Utils.getData('/tareas/tareas-de-servicio/' + servicioId)
		.then((data) => {
			setTareas(data)
		});
	}

	const loadInit = (column) => {
		if(props.showTareas && props.showTareas.length > 0){
			if (column) {
				setLoading(true);
				Utils.getData('/tareas/simple-search-presupuesto?column=' + column + '&value=' + '' + proveedorTareaQS)
				.then((data) => {
					setTareas(data)
				})
				.finally(() => {
					setLoading(false)
				});
			}else{
				if(props.showTareas.includes('id')){
					column = 'id'
				}else if (props.showTareas.includes('nombre')) {
					column = 'nombre'
				}
				if (column && busquedaPor === 'nombre') {
					setLoading(true);
					Utils.getData('/tareas/simple-search-presupuesto?column=' + column + '&value=' + '' + proveedorTareaQS)
					.then((data) => {
						setTareas(data)
					})
					.finally(() => {
						setLoading(false)
					});
				}
			}	
		}
	}

	return (
		<React.Fragment>
			{redirectTo && <Redirect push to={redirectTo} />}
			{loading && <Loading />}
			<div className="table-responsive" style={{padding: "15px"}}>
				<div className="row" style={{marginRight: "3px", marginLeft: "3px", padding: "6px"}}>
					{props.soloLectura ? (
						<div className="text-muted" style={{padding: '6px', display: 'flex', alignItems: 'center'}}>
							<span className="text-info" data-tooltip="tooltip" data-placement="top"
								title={intl.formatMessage(
									{ id: 'PresupuestoDetalladoItem.sinPermisoCarga.tooltip', defaultMessage: 'No tenés permiso para cargar {tipo} en este presupuesto. Podés ver los ítems ya cargados.' },
									{ tipo: intl.formatMessage({ id: 'Mano_de_Obra', defaultMessage: 'Mano de Obra' }) }
								)}
								style={{cursor: 'pointer'}}>
								<i className="fa fa-info-circle"></i>
							</span>
							<span className="ml-2">
								<FormattedMessage
									id="PresupuestoDetalladoItem.sinPermisoCarga"
									defaultMessage="No tenés permiso para cargar {tipo}."
									values={{ tipo: intl.formatMessage({ id: 'Mano_de_Obra', defaultMessage: 'Mano de Obra' }) }}
								/>
							</span>
						</div>
					) : (
					<>
					<Grid container item xs={12} spacing={3} style={{marginBottom: props.showTareas.includes('detalle') ? 8 : 20}}>
						{props.showTareas.filter(function(f) { return f !== 'detalle'; }).map(field => renderField(field))}
						<Grid component={Box} item xs={1}>
							<form noValidate autoComplete="off">
								<button
									className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main"
									style={{ height: 49 }}
									onClick={() => addTarea()}
									disabled={validate() || props.soloLectura}
								>
									<i className="ft-plus"></i>
								</button>
							</form>
						</Grid>
					</Grid>
					{props.showTareas.includes('detalle') && (
						<div style={{width: '100%', marginBottom: 20}}>
							<TextField
								id="detalle"
								type="text"
								multiline
								rows={1}
								InputLabelProps={{ shrink: newPresupuestoTarea.detalle ? true : undefined }}
								label={intl.formatMessage({ id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' })}
								placeholder={intl.formatMessage({ id: 'Presupuesto.Detalle', defaultMessage: 'Detalle' })}
								value={newPresupuestoTarea.detalle}
								onChange={e => {
									const value = e.target.value;
									if (value.length <= 60) {
										handleMaterialChange('detalle', value);
									}
								}}
								inputProps={{ maxLength: 60 }}
								variant="outlined"
								fullWidth
							/>
							<div style={{textAlign: 'right', fontSize: '0.75rem', color: '#666', marginTop: '2px'}}>
								{newPresupuestoTarea.detalle ? newPresupuestoTarea.detalle.length : 0}/60
							</div>
						</div>
					)}
					</>
					)}
				</div>
				<PresupuestoDetalladoTareaGrid
					intl={props.intl}
					presupuestoTareas={props.presupuestoTareas}
					loading={(state) => setLoadingAndUpdate(state)}
					deleteTarea={props.deleteTarea}
					updatePresupuestoTarea={props.updatePresupuestoTarea}
					showTareas={props.showTareas}
					mecanicos={mecanicos}
					clasificaciones={props.clasificaciones || []}
					esRecotizacionParcial={props.esRecotizacionParcial || false}
					soloLectura={props.soloLectura || false}
				/>
				<div className="row p-1" style={{justifyContent: "right"}}>
					<label className="col-md-2 label-control col-form-label" htmlFor="total_mano_de_obra">
						{props.labelTotal ? props.labelTotal : <FormattedMessage id="Presupuesto.Total_Mano_de_Obra" defaultMessage="Total Mano de Obra"/>} {requiredSymbol}:
					</label>
					<div className="col-md-3">
						<div>
							<input disabled 
								type="number"
								className="form-control text-right pr-1"
								id="total_mano_de_obra"
								name="total_mano_de_obra"
								value={formatCost(props.totalManoObra)}
							/>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default injectIntl(PresupuestoDetalladoTarea);
